import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import {
  PaymentMethod,
  PaymentMethodCreate,
  PaymentMethodLight,
  PaymentMethodUpdate
} from "src/app/backend/models/payment-method/payment-method";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

@Injectable()
export class PaymentMethodBackend {
  constructor(private readonly http: HttpClient) {}

  load(id: string): Observable<PaymentMethod> {
    return this.http.get<PaymentMethod>(
      `${environment.snoots.api.billing}/payment-methods/${id}`
    );
  }

  loadLight(id: string): Observable<PaymentMethodLight> {
    return this.http.get<PaymentMethodLight>(
      `${environment.snoots.api.billing}/payment-methods/${id}`,
      {
        params: {
          light: true
        }
      }
    );
  }

  list(
    disabled: boolean,
    request: PageRequest
  ): Observable<PaginatedResult<PaymentMethodLight>> {
    return this.http.get<PaginatedResult<PaymentMethod>>(
      `${environment.snoots.api.billing}/payment-methods`,
      {
        params: {
          p: request.page,
          s: request.pageSize,
          disabled: disabled
        }
      }
    );
  }

  listLight(
    disabled: boolean,
    request: PageRequest
  ): Observable<PaginatedResult<PaymentMethodLight>> {
    return this.http.get<PaginatedResult<PaymentMethod>>(
      `${environment.snoots.api.billing}/payment-methods`,
      {
        params: {
          p: request.page,
          s: request.pageSize,
          disabled: disabled,
          light: true
        }
      }
    );
  }

  listAllLight(): Observable<PaymentMethodLight[]> {
    return this.listLight(false, {
      page: 1,
      pageSize: 10000
    }).pipe(map((response) => response.docs));
  }

  @UserNotify({
    successMessage: marker("Metodo di pagamento creato"),
    errorMessage: marker("Impossibile creare metodo di pagamento")
  })
  create(request: PaymentMethodCreate): Observable<PaymentMethod> {
    return this.http.post<PaymentMethod>(
      `${environment.snoots.api.billing}/payment-methods`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Metodo di pagamento aggiornato"),
    errorMessage: marker("Impossibile aggiornare metodo di pagamento")
  })
  update(id: string, request: Partial<PaymentMethodUpdate>): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.billing}/payment-methods/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Metodo di pagamento rimosso"),
    errorMessage: marker("Impossibile rimuovere metodo di pagamento")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.billing}/payment-methods/${id}`
    );
  }

  @UserNotify({
    successMessage: marker("Metodo di pagamento rimosso"),
    errorMessage: marker("Impossibile rimuovere metodo di pagamento")
  })
  disable(id: string): Observable<void> {
    return this.http.put<void>(
      `${environment.snoots.api.billing}/payment-methods/${id}/disable`,
      {}
    );
  }
}
